module.exports = __webpack_public_path__ + "img/dea-formazione-ico-storia-geografia.045fe1e3.svg";